import { toAbsoluteUrl } from "src/resources/helpers";
import type { MarketplaceAccount } from "../../../types/marketplaceAccount";
import { getAccountConnectionState, getAccountDisplayName, getAccountLastUpdated } from "../../../utils/marketplaceConnectionStatus";
import { MarketplaceAccountActions } from "../shared/MarketplaceAccountActions";
import { MarketplaceConnectionStatus } from "../shared/MarketplaceConnectionStatus";
import { MarketplaceChannelControls } from "../shared/MarketplaceChannelControls";

type Props = { account: MarketplaceAccount; onChanged: () => void };

function formatUpdated(account: MarketplaceAccount) {
  const updated = getAccountLastUpdated(account);
  return updated ? new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(updated) : "-";
}

export function MarketplaceAccountRow({ account, onChanged }: Props) {
  const logo = toAbsoluteUrl(`/media/logos/marketplace/${account.type.toLowerCase()}.png`);
  return (
    <tr className="tw-border-t tw-border-slate-100 hover:tw-bg-slate-50 dark:tw-border-slate-800 dark:hover:tw-bg-slate-800/50">
      <td className="tw-px-6 tw-py-4">
        <div className="tw-flex tw-items-center tw-gap-3">
          <img src={logo} alt="" className="tw-h-9 tw-w-9 tw-rounded-md tw-object-contain" onError={(event) => { event.currentTarget.style.display = "none"; }} />
          <div className="tw-min-w-0"><p className="tw-truncate tw-font-semibold tw-text-slate-900 dark:tw-text-white">{getAccountDisplayName(account)}</p><p className="tw-truncate tw-text-xs tw-text-slate-500">{account.marketplaceShopId || account.searchKey || account.type}</p></div>
        </div>
      </td>
      <td className="tw-px-4 tw-py-4"><div className="tw-flex tw-items-center tw-gap-2"><MarketplaceConnectionStatus state={getAccountConnectionState(account, "erp")} compact /><MarketplaceChannelControls account={account} channel="erp" onChanged={onChanged} /></div></td>
      <td className="tw-px-4 tw-py-4"><div className="tw-flex tw-items-center tw-gap-2"><MarketplaceConnectionStatus state={getAccountConnectionState(account, "chat")} compact /><MarketplaceChannelControls account={account} channel="chat" onChanged={onChanged} /></div></td>
      <td className="tw-px-4 tw-py-4 tw-text-sm tw-text-slate-600 dark:tw-text-slate-300">{formatUpdated(account)}</td>
      <td className="tw-px-6 tw-py-4"><MarketplaceAccountActions account={account} onChanged={onChanged} /></td>
    </tr>
  );
}
